export const websiteSEO = {
    home: {
        title: "Voice Up | Cours de chant tous niveaux à Genève",
        description:
            "Cours de chant à Genève, pose de voix et coach vocal pour amateur et professionnel, méthode Complete Vocal Technique.",
        canonHREF: "https://myvoiceup.ch/",
        titleEN: "Voice Up | Singing Lessons for All Levels in Geneva",
        descriptionEN:
            "Singing lessons in Geneva, voice coaching for amateurs and professionals, Complete Vocal Technique method.",
        ogImage: "https://myvoiceup.ch/website_og_image.png",
    },
    program: {
        title: "Méthode | Voice Up",
        description:
            "Méthode et philosophie d’enseignement de la professeure de chant et coach vocal Tania Guillin.",
        canonHREF: "https://myvoiceup.ch/methode",
        titleEN: "Method | Voice Up",
        descriptionEN:
            "Teaching method and philosophy of singing teacher and vocal coach Tania Guillin.",
        ogImage: "https://myvoiceup.ch/website_og_image.png",
    },
    about: {
        title: "À propos | Voice Up",
        description: "Curriculum et videos des projets musicaux de Tania Guillin.",
        canonHREF: "https://myvoiceup.ch/tania",
        titleEN: "About | Voice Up",
        descriptionEN: "Curriculum and videos of Tania Guillin’s musical projects.",
        ogImage: "https://myvoiceup.ch/website_og_image.png",
    },
    conditions: {
        title: "Conditions | Voice Up",
        description: "Les conditions contractuelles des cours chez Voice Up.",
        canonHREF: "https://myvoiceup.ch/conditions",
        titleEN: "Terms & Conditions | Voice Up",
        descriptionEN: "Contractual terms and conditions for lessons at Voice Up.",
        ogImage: "https://myvoiceup.ch/website_og_image.png",
    },
    pricing: {
        title: "Tarifs | Voice Up",
        description: "Les différent plans tarifaires pour les sessions de chant chez Voice Up.",
        canonHREF: "https://myvoiceup.ch/tarifs",
        titleEN: "Pricing | Voice Up",
        descriptionEN: "Pricing plans for singing lessons at Voice Up.",
        ogImage: "https://myvoiceup.ch/website_og_image.png",
    },
    contact: {
        title: "Contact | Voice Up",
        description: "Formulaire de contact pour les sessions de chant à Voice Up.",
        canonHREF: "https://myvoiceup.ch/contact",
        titleEN: "Contact | Voice Up",
        descriptionEN: "Contact form for singing lessons at Voice Up.",
        ogImage: "https://myvoiceup.ch/website_og_image.png",
    },
    enroll: {
        title: "Inscription | Voice Up",
        description: "Faire une demande d’inscription pour les cours de chant Voice Up.",
        canonHREF: "https://myvoiceup.ch/inscription",
        titleEN: "Enroll | Voice Up",
        descriptionEN: "Enrollment request for Voice Up singing lessons.",
        ogImage: "https://myvoiceup.ch/website_og_image.png",
    },
};
